module.exports = __webpack_public_path__ + "media/giftcards/GC_Confirmation-d8a606b9.png";